// WordPress like to return special characters as encoded HTML entities
export function decodeHtml(htmlString: string) {
    return htmlString.replace(/&#(\d+);/g, (_match, dec) => {
      return String.fromCharCode(dec);
    });
};